import '@babel/polyfill';import 'uni-pages';import 'uni-h5';import App from './App'
import store from './store'

import Vue from 'vue'
Vue.config.productionTip = false
App.mpType = 'app'

// 引入全局TuniaoUI
import TuniaoUI from 'tuniao-ui'
Vue.use(TuniaoUI)

// 引入TuniaoUI提供的vuex简写方法
let vuexStore = require('@/store/$t.mixin.js')
Vue.mixin(vuexStore)

// 引入TuniaoUI对小程序分享的mixin封装
let mpShare = require('tuniao-ui/libs/mixin/mpShare.js')
Vue.mixin(mpShare)

import moment from 'moment'
Vue.prototype.zmoment = moment;

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import i18n from './lang/index' 
Vue.prototype._i18n = i18n
Vue.prototype.i18nArr = ['zh', 'cht', 'en', 'vie', 'id', 'kor', 'th', 'jp', 'ara']
Vue.prototype.langCur = uni.getStorageSync("lang") ? uni.getStorageSync("lang") : "zh";
Vue.prototype.langSwitch = function(langCur) {
	i18n.locale = langCur;
	uni.setStorageSync("lang", langCur);
	Vue.prototype.langCur = langCur;
	uni.reLaunch({
	  url: '/pages/planet'
	});
	// window.location.reload();
}

Vue.prototype.fmtMongoUid = function(id) {
    return '' + new Date(id.date).getTime();
}
Vue.prototype.fixScale = 4; // 显示精度
Vue.prototype.fixScaleZero = 0; // 显示精度
Vue.prototype.transferTimeLimit = 10 * 1000; // 限制链上操作间隔为 10 秒
Vue.prototype.toast = function(title) {
	uni.showToast({
		image: "https://cchain-res.s3.ap-northeast-1.amazonaws.com/tokens/cc.png",
		icon: "none",
		position: "bottom",
		title: title,
		duration: 3000,
	});

	return false;
}

// 注意 () => {} 和 async () => {} 的区别
Vue.prototype.confirm = function(title, content, confirmCb, cancelCb) {
	uni.showModal({
		title: title,
		content: content,
		showCancel: true,
		cancelText: '取消',
		cancelColor: 'white',
		confirmText: '确定',
		confirmColor: '#03b752',
		success: (res) => {
			if (res.cancel) {
				cancelCb && cancelCb()
			} else if (res.confirm) {
				confirmCb && confirmCb()
			}
		}
	})
}

Vue.prototype.copy = function(text) {














	Vue.prototype.$copyText(text).then(
		res => {
			uni.showToast({
				icon: "none",
				position: "bottom",
				title: this.t('zlang143'),
				duration: 2000,
			});
		}
	)

}

Vue.prototype.goto = function(e) {
	uni.navigateTo({
		url: e,
	});
}

// 好像手机上本路由跳转不好用
Vue.prototype.gotoLink = function(url) {




	window.location.href = url;

}

Vue.prototype.hiddenAddress = function(address) {
	if (address) {
		if (address.length > 6) {
			return address.substr(0, 6) + "..." + address.substr(address.length - 4, address.length);
		} else {
			return address.substr(0, 6) + "...";
		}
	} else {
		return "";
	}
}

Vue.prototype.formatUnitsValue = function(rawVal, decimals) {
    const raw = String(rawVal || '').trim();
    if (!raw) return '0';
    if (!/^\d+$/.test(raw)) return raw;
    const dec = Number(decimals);
    if (!Number.isFinite(dec) || dec <= 0) return raw;
    const pad = raw.padStart(dec + 1, '0');
    const whole = pad.slice(0, -dec);
    const frac = pad.slice(-dec).replace(/0+$/, '');
    return frac ? (whole + '.' + frac) : whole;
};

Vue.prototype.info = {'gasPrice': 1230000000, 'gasLimit': 500000, 'address':'0x0000000000000000000000000000000000000000','CC': 0,'USDT': 0, 'totalFeeInvite': 0, 'myFeeInvites': 0, 'lockRecords': [], 'ocLockRecord': null, 'ocLockContractAddress': '0xeBd4848194a11E0fb068134db7F32E0b70c7c888', 'addressDead':'0x000000000000000000000000000000000000dEaD', 'addressMarket':'0xF4Afe5CB8b7546893d5667108422aB372B3C8f08', 'ocEventType': 'invite-request', 'ocEventLogs': [], 'ocEventLoading': false, 'ocEventProgress': null}
Vue.prototype.info.symbols = {'USDT': '0xf87196623bfd35bb3c64ef0036c5e92bece768ea', 'oc': '0xeBd4848194a11E0fb068134db7F32E0b70c7c888', 'lp': '0x6a02Ae8Ee33EB3712798Ac1cd0639325a1aacD7b'};

Vue.prototype.web3;
var web3;
Vue.prototype.contractLbb;
// 2. 轮询检测并启动
let retry = 0;
const timer = setInterval(async () => {
    retry++;
    // 如果检测到环境，或者等够了 2s (20 * 100ms)
    if (window.ethereum || retry >= 20) {
        clearInterval(timer);
        
        if (window.ethereum) {
            // 只要环境好了，就执行你原本的 startApp
            if (true) {
            	let Web3 = require('web3');
            	var web3Provider;
            	if (window.ethereum) {
            		web3Provider = window.ethereum;
            		try {
            			window.ethereum.enable();
            		} catch (error) {
            			console.error("User denied account access")
            		}
            	}
            	web3 = new Web3(web3Provider);
            	web3.eth.getChainId(function(err, res) {
            		if (!err) {
            			if (res != 51112) {
            				window.ethereum.request({
            					method: 'wallet_addEthereumChain',
            					params: [{
            						chainId: web3.utils.numberToHex(51112),
            						chainName: 'C Chain',
            						nativeCurrency: {
            							name: 'C Coin',
            							symbol: 'CC',
            							decimals: 18
            						},
            						rpcUrls: ['https://cc.cchain-gov.org'],
            						blockExplorerUrls: ['https://scan.cchain-gov.org']
            					}]
            				}).then((res) => {
            					console.log("C Chain: " + res);
            				}).catch((err) => {
            					console.log(err);
            				})
            			} else {
            				Vue.prototype.web3 = web3;
            				web3.eth.getAccounts(function(error, result) {
            					if (!error) {
            						Vue.prototype.info.address = result[0];
            						// Vue.prototype.info.address = "0x09B916E834bd134cFb36aC7D0298FDD13FF05d62";
            						Vue.prototype.doInit();
            						
            						web3.eth.getBalance(Vue.prototype.info.address).then(function(result){
            							Vue.prototype.info.CC = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            							console.log("CC: " + Vue.prototype.info.CC);
            						});
            						
            						var symbol18ContractAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
            						for (let key in Vue.prototype.info.symbols) {
            							if (key == 'oc') {
            								continue;
            							}
            							var symbol18Contract = new web3.eth.Contract(symbol18ContractAbi, Vue.prototype.info.symbols[key], {});
            							symbol18Contract.methods.balanceOf(Vue.prototype.info.address).call({}, function(error, result) {
            								if (!error) {
            									Vue.prototype.info[key] = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            									console.log(key + ": " + Vue.prototype.info[key]);
            								} else {
            									console.log(error);
            								}
            							});
            						}
            						
            						var lbbContractAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newPoolAddress","type":"address"}],"name":"CswapPairUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"bool","name":"isExempt","type":"bool"}],"name":"FeeExemptStatusUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_marketingFeeRate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"_referrerFeeRate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"_deadFeeRate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"_lpFeeRate","type":"uint256"}],"name":"FeeRatiosUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"marketingAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"referrerAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lpAmount","type":"uint256"}],"name":"FeesDistributed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"param","type":"uint256"}],"name":"InviteParamUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newWallet","type":"address"}],"name":"MarketingWalletUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"referee","type":"address"},{"indexed":true,"internalType":"address","name":"potentialReferreruint","type":"address"},{"indexed":false,"internalType":"uint256","name":"referFee","type":"uint256"}],"name":"PotentialReferrerRecorded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"referee","type":"address"},{"indexed":true,"internalType":"address","name":"referrer","type":"address"}],"name":"ReferralConfirmed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"INITIAL_SUPPLY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"REFERRAL_AMOUNT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"autoCleanLpAddrs","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cswapPair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cswapRouter","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"deadAddr","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"deadFeeRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getInviteTimes","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getInvites","outputs":[{"internalType":"address[]","name":"","type":"address[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLpsParams","outputs":[{"internalType":"address[]","name":"","type":"address[]"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getRefers","outputs":[{"internalType":"address[]","name":"","type":"address[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getRefersTime","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"inviteTimes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"invites","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"isFeeExempt","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"lpAddrs","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lpFeeRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lpMinRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"marketingFeeRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"marketingWallet","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"myFeeInvites","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"myFeeLps","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"referrTimes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"referrals","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"referrerFeeRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"referrerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"newLpAddrs","type":"address[]"}],"name":"refreshLpAddrs","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"pairAddress","type":"address"}],"name":"setCswapPair","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"exempt","type":"bool"}],"name":"setFeeExempt","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_marketingFeeRate","type":"uint256"},{"internalType":"uint256","name":"_referrerFeeRate","type":"uint256"},{"internalType":"uint256","name":"_deadFeeRate","type":"uint256"},{"internalType":"uint256","name":"_lpFeeRate","type":"uint256"}],"name":"setFeeRatios","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"param","type":"uint256"}],"name":"setInviteParam","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_lpMinRate","type":"uint256"}],"name":"setLpMinRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newWallet","type":"address"}],"name":"setMarketingWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"inx","type":"uint256"}],"name":"setReferrer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFeeDeads","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFeeInvite","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFeeLps","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFeeMarket","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFeeRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"usdtAddr","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}];
                                                lbbContractAbi = lbbContractAbi.concat([
                                                    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"baseAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalReward","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"layers","type":"uint256"}],"name":"BonusDistributed","type":"event"},
                                                    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"referrer","type":"address"},{"indexed":false,"internalType":"uint256","name":"usdtAmount","type":"uint256"}],"name":"EffectiveLpAccountUpdated","type":"event"},
                                                    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"payer","type":"address"},{"indexed":true,"internalType":"address","name":"beneficiary","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lockedValue","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ocPrice","type":"uint256"}],"name":"OcLocked","type":"event"},
                                                    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beneficiary","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"OcLockClaimed","type":"event"},
                                                    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beneficiary","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint8","name":"releaseType","type":"uint8"}],"name":"OcLockReleased","type":"event"},
                                                    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"baseAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalReleased","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"levels","type":"uint256"}],"name":"LockDynamicReleased","type":"event"},
                                                    {"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"effectiveLpAccount","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},
                                                    {"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"effectiveDirectCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},
                                                    {"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"lockInfos","outputs":[{"internalType":"uint256","name":"lockedAmount","type":"uint256"},{"internalType":"uint256","name":"lockedValue","type":"uint256"},{"internalType":"uint256","name":"releasedAmount","type":"uint256"},{"internalType":"uint256","name":"claimedAmount","type":"uint256"},{"internalType":"uint256","name":"lastStaticReleaseTime","type":"uint256"},{"internalType":"bool","name":"isActive","type":"bool"}],"stateMutability":"view","type":"function"},
                                                    {"inputs":[],"name":"totalLockedUnclaimed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},
                                                    {"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getOcLockClaimable","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},
                                                    {"inputs":[],"name":"claimOcLock","outputs":[],"stateMutability":"nonpayable","type":"function"}
                                                ]);
            						var ocContract = new web3.eth.Contract(lbbContractAbi, Vue.prototype.info.symbols['oc'], {});
            						ocContract.methods.balanceOf(Vue.prototype.info.address).call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.oc = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("OC: " + Vue.prototype.info['oc']);
            							} else {
            								console.log(error);
            							}
            						});
            						Vue.prototype.contractLbb = ocContract;
                                                Vue.prototype.info.fetchOcLockForTarget = async function(target) {
                                                    try {
                                                        var lockInfo = await ocContract.methods.lockInfos(target.address).call({});
                                                        var claimable = await ocContract.methods.getOcLockClaimable(target.address).call({});
                                                        var hasLock = lockInfo.lockedAmount && lockInfo.lockedAmount.toString() !== '0';
                                                        var claimedAmount = web3.utils.toBN(lockInfo.claimedAmount.toString());
                                                        var claimableAmount = web3.utils.toBN(claimable.toString());
                                                        var releasedDisplayAmount = claimedAmount.add(claimableAmount);
                                                        var record = hasLock ? {
                                                            name: target.name,
                                                            address: target.address,
                                                            active: !!lockInfo.isActive,
                                                            lockedAmount: Number(Vue.prototype.formatUnitsValue(lockInfo.lockedAmount.toString(), 18)).toFixed(4),
                                                            lockedValue: Number(Vue.prototype.formatUnitsValue(lockInfo.lockedValue.toString(), 18)).toFixed(4),
                                                            releasedAmount: Number(Vue.prototype.formatUnitsValue(releasedDisplayAmount.toString(), 18)).toFixed(4),
                                                            settledReleasedAmount: Number(Vue.prototype.formatUnitsValue(lockInfo.releasedAmount.toString(), 18)).toFixed(4),
                                                            claimedAmount: Number(Vue.prototype.formatUnitsValue(lockInfo.claimedAmount.toString(), 18)).toFixed(4),
                                                            claimable: Number(Vue.prototype.formatUnitsValue(claimable.toString(), 18)).toFixed(4),
                                                            lastStaticReleaseTime: lockInfo.lastStaticReleaseTime
                                                        } : null;
														if (!record || record.lockedAmount <= 0) {
															record = null;
														}
                                                        Vue.prototype.info.ocLockRecord = record;
                                                        console.log("oc-lock-" + target.name + ": " + JSON.stringify(record));
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                };
                                                Vue.prototype.info.fetchMyOcLock = function() {
                                                    Vue.prototype.info.fetchOcLockForTarget({
                                                        name: 'OC',
                                                        address: Vue.prototype.info.address
                                                    });
                                                };
                                                Vue.prototype.info.fetchMyOcLock();
            						var lbbEventBlockTimeStorageKey = 'ocBlockTimes-v1';
            						var lbbEventBlockTimes = {};
            						try {
            							lbbEventBlockTimes = uni.getStorageSync(lbbEventBlockTimeStorageKey) || {};
            						} catch (error) {
            							console.log(error);
            							lbbEventBlockTimes = {};
            						}
            						var saveLbbEventBlockTimes = function() {
            							try {
            								uni.setStorageSync(lbbEventBlockTimeStorageKey, lbbEventBlockTimes);
            							} catch (error) {
            								console.log(error);
            							}
            						};
            						var getLbbEventBlockTime = async function(event) {
            							if (!event.blockNumber) {
            								return '0';
            							}
            							if (!lbbEventBlockTimes[event.blockNumber]) {
            								var block = await web3.eth.getBlock(event.blockNumber);
            								lbbEventBlockTimes[event.blockNumber] = block && block.timestamp ? block.timestamp.toString() : '0';
            								saveLbbEventBlockTimes();
            							}
            							return lbbEventBlockTimes[event.blockNumber];
            						};
            						var formatOcAmount = function(raw) {
            							return Number(Vue.prototype.formatUnitsValue((raw || '0').toString(), 18)).toFixed(4);
            						};
            						var eventCache = {};
            						var ocEventFromBlock = 3050000;
            						var getCachedEvents = async function(eventName, options, cacheKey, force, fromBlock, toBlock) {
            							var rangeFromBlock = fromBlock || ocEventFromBlock;
            							var rangeToBlock = toBlock || 'latest';
            							var key = (cacheKey || (eventName + JSON.stringify(options || {}))) + '-' + rangeFromBlock + '-' + rangeToBlock;
            							if (!force && eventCache[key]) {
            								return eventCache[key];
            							}
            							var events = await ocContract.getPastEvents(eventName, Object.assign({
            								fromBlock: rangeFromBlock,
            								toBlock: rangeToBlock
            							}, options || {}));
            							eventCache[key] = events;
            							return events;
            						};
            						var receiptCache = {};
            						var txDerivedCacheStorageKey = 'ocTxDerived-v1';
            						var txDerivedCache = {};
            						try {
            							txDerivedCache = uni.getStorageSync(txDerivedCacheStorageKey) || {};
            						} catch (error) {
            							console.log(error);
            							txDerivedCache = {};
            						}
            						var saveTxDerivedCache = function() {
            							try {
            								uni.setStorageSync(txDerivedCacheStorageKey, txDerivedCache);
            							} catch (error) {
            								console.log(error);
            							}
            						};
            						var referrerOfCacheStorageKey = 'ocReferrerOf-v1';
            						var referrerOfCache = {};
            						try {
            							referrerOfCache = uni.getStorageSync(referrerOfCacheStorageKey) || {};
            						} catch (error) {
            							console.log(error);
            							referrerOfCache = {};
            						}
            						var saveReferrerOfCache = function() {
            							try {
            								uni.setStorageSync(referrerOfCacheStorageKey, referrerOfCache);
            							} catch (error) {
            								console.log(error);
            							}
            						};
            						var getCachedReferrerOf = async function(account) {
            							var key = (account || '').toLowerCase();
            							if (!key) return '';
            							if (typeof referrerOfCache[key] !== 'undefined') {
            								return referrerOfCache[key];
            							}
            							var referrer = await ocContract.methods.referrerOf(account).call({});
            							referrerOfCache[key] = referrer || '';
            							saveReferrerOfCache();
            							return referrerOfCache[key];
            						};
            						var getCachedReceipt = async function(txHash, force) {
            							if (!force && receiptCache[txHash]) {
            								return receiptCache[txHash];
            							}
            							var receipt = await web3.eth.getTransactionReceipt(txHash);
            							receiptCache[txHash] = receipt;
            							return receipt;
            						};
            						var collectTradeUsersFromReceipt = async function(txHash, transferFrom, force) {
            							var derivedKey = txHash + '-tradeUsers-' + (transferFrom || '').toLowerCase();
            							if (!force && txDerivedCache[derivedKey]) {
            								return txDerivedCache[derivedKey];
            							}
            							var users = {};
            							var pairAddress = (Vue.prototype.info.symbols['lp'] || '').toLowerCase();
            							if (transferFrom) {
            								users[transferFrom.toLowerCase()] = true;
            							}
            							if (!pairAddress) {
            								var simpleUsers = Object.keys(users);
            								txDerivedCache[derivedKey] = simpleUsers;
            								saveTxDerivedCache();
            								return simpleUsers;
            							}
            							var receipt = await getCachedReceipt(txHash, force);
            							var topic = web3.utils.sha3('Transfer(address,address,uint256)');
            							(receipt.logs || []).forEach(function(log) {
            								if ((log.address || '').toLowerCase() !== (Vue.prototype.info.symbols['oc'] || '').toLowerCase() || !log.topics || log.topics[0] !== topic) {
            									return;
            								}
            								var decoded = web3.eth.abi.decodeLog([
            									{ indexed: true, name: 'from', type: 'address' },
            									{ indexed: true, name: 'to', type: 'address' },
            									{ indexed: false, name: 'value', type: 'uint256' }
            								], log.data, [log.topics[1], log.topics[2]]);
            								if ((decoded.to || '').toLowerCase() === pairAddress) {
            									users[(decoded.from || '').toLowerCase()] = true;
            								}
            								if ((decoded.from || '').toLowerCase() === pairAddress) {
            									users[(decoded.to || '').toLowerCase()] = true;
            								}
            							});
            							var tradeUsers = Object.keys(users);
            							txDerivedCache[derivedKey] = tradeUsers;
            							saveTxDerivedCache();
            							return tradeUsers;
            						};
            						var txHasOcEvent = async function(txHash, eventSignature, force) {
            							var derivedKey = txHash + '-hasEvent-' + eventSignature;
            							if (!force && typeof txDerivedCache[derivedKey] !== 'undefined') {
            								return !!txDerivedCache[derivedKey];
            							}
            							var receipt = await getCachedReceipt(txHash, force);
            							var topic = web3.utils.sha3(eventSignature);
            							var ocAddress = (Vue.prototype.info.symbols['oc'] || '').toLowerCase();
            							var hasEvent = (receipt.logs || []).some(function(log) {
            								return (log.address || '').toLowerCase() === ocAddress && log.topics && log.topics[0] === topic;
            							});
            							txDerivedCache[derivedKey] = hasEvent;
            							saveTxDerivedCache();
            							return hasEvent;
            						};
            						var pushOcEventRecord = async function(records, event, typeKey, titleKey, amount, unit, extra, subTypeKey) {
            							records.push({
            								typeKey: typeKey,
            								titleKey: titleKey,
            								subTypeKey: subTypeKey || titleKey,
            								time: await getLbbEventBlockTime(event),
            								amount: amount || '',
            								unit: unit || '',
            								extra: extra || '',
            								txHash: event.transactionHash,
            								blockNumber: event.blockNumber || 0
            							});
            						};
            						var ocEventCacheVersion = 'v3';
            						var getOcEventStorageKey = function(account, type) {
            							return 'ocEventLogs-' + ocEventCacheVersion + '-' + account + '-' + type;
            						};
            						var getRecordCacheId = function(record) {
            							return [
            								record.txHash || '',
            								record.titleKey || '',
            								record.amount || '',
            								record.unit || '',
            								record.extra || '',
            								record.blockNumber || ''
            							].join('|');
            						};
            						var mergeOcEventRecords = function(oldRecords, newRecords) {
            							var seen = {};
            							var merged = [];
            							(oldRecords || []).concat(newRecords || []).forEach(function(record) {
            								var id = getRecordCacheId(record);
            								if (seen[id]) return;
            								seen[id] = true;
            								merged.push(record);
            							});
            							merged.sort(function(a, b) {
            								return Number(b.time || 0) - Number(a.time || 0);
            							});
            							return merged;
            						};
            						var loadStoredOcEventCache = function(account, type) {
            							try {
            								var cached = uni.getStorageSync(getOcEventStorageKey(account, type));
            								if (cached && cached.records && typeof cached.lastBlock !== 'undefined') {
            									return {
            										records: cached.records || [],
            										lastBlock: Number(cached.lastBlock || 0)
            									};
            								}
            							} catch (error) {
            								console.log(error);
            							}
            							return { records: [], lastBlock: ocEventFromBlock - 1 };
            						};
            						var saveStoredOcEventCache = function(account, type, records, lastBlock) {
            							try {
            								uni.setStorageSync(getOcEventStorageKey(account, type), {
            									lastBlock: Number(lastBlock || ocEventFromBlock),
            									records: records || []
            								});
            							} catch (error) {
            								console.log(error);
            							}
            						};
            						Vue.prototype.info.ocEventType = 'invite-request';
            						Vue.prototype.info.ocEventLogs = [];
            						Vue.prototype.info.ocEventLoading = false;
            						Vue.prototype.info.ocEventProgress = null;
            						Vue.prototype.info.ocEventCache = {};
            						Vue.prototype.info.ocEventRequestSeq = 0;
            						Vue.prototype.info.fetchOcEventLogs = async function(type, force) {
            							type = type || Vue.prototype.info.ocEventType || 'invite-request';
            							var requestSeq = (Vue.prototype.info.ocEventRequestSeq || 0) + 1;
            							Vue.prototype.info.ocEventRequestSeq = requestSeq;
            							Vue.prototype.info.ocEventType = type;
            							Vue.prototype.info.ocEventLogs = [];
            							Vue.prototype.info.ocEventLoading = true;
            							Vue.prototype.info.ocEventProgress = null;
            							var isRewardQuery = type === 'reward-direct' || type === 'reward-liquidity' || type === 'reward';
            							var accountForCache = (Vue.prototype.info.address || '').toLowerCase();
            							if (!force) {
            								var storedCache = loadStoredOcEventCache(accountForCache, type);
            								if (storedCache.records.length) {
            									Vue.prototype.info.ocEventLogs = storedCache.records;
            									Vue.prototype.info.ocEventLoading = !!isRewardQuery;
            								}
            							}
            							var loadOcEventRecords = async function(fromBlock, rangeKey, toBlock) {
            								var account = (Vue.prototype.info.address || '').toLowerCase();
            								var records = [];
            								var wants = function(key) {
            									if (type === key) return true;
            									if (type === 'invite') return key.indexOf('invite-') === 0;
            									if (type === 'reward') return key.indexOf('reward-') === 0;
            									if (type === 'bonus') return key.indexOf('bonus-') === 0;
            									if (type === 'lock') return key.indexOf('lock-') === 0;
            									return false;
            								};
            								if (wants('lock-lock')) {
            									var lockEvents = await getCachedEvents('OcLocked', { filter: { beneficiary: Vue.prototype.info.address } }, 'OcLocked-beneficiary-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < lockEvents.length; i++) {
            										var v = lockEvents[i].returnValues;
            										await pushOcEventRecord(records, lockEvents[i], 'lock', 'eventOcLocked', formatOcAmount(v.amount), 'OC', formatOcAmount(v.lockedValue) + ' USDT', 'eventOcLocked');
            									}
            								}
            								if (wants('lock-static') || wants('lock-dynamic')) {
            									var releaseEvents = await getCachedEvents('OcLockReleased', { filter: { beneficiary: Vue.prototype.info.address } }, 'OcLockReleased-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < releaseEvents.length; i++) {
            										var rv = releaseEvents[i].returnValues;
            										var isDynamicRelease = rv.releaseType.toString() === '2';
            										if ((isDynamicRelease && !wants('lock-dynamic')) || (!isDynamicRelease && !wants('lock-static'))) {
            											continue;
            										}
            										var releaseTitle = rv.releaseType.toString() === '2' ? 'eventOcDynamicRelease' : 'eventOcStaticRelease';
            										await pushOcEventRecord(records, releaseEvents[i], 'lock', releaseTitle, formatOcAmount(rv.amount), 'OC', '', releaseTitle);
            									}
            								}
            								if (wants('bonus-ten-level')) {
            									var transferBonusEvents = await getCachedEvents('Transfer', {
            										filter: { from: Vue.prototype.info.symbols['oc'], to: Vue.prototype.info.address }
            									}, 'Transfer-bonus-to-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < transferBonusEvents.length; i++) {
            										if (await txHasOcEvent(transferBonusEvents[i].transactionHash, 'BonusDistributed(address,uint256,uint256,uint256)', force)) {
            											await pushOcEventRecord(records, transferBonusEvents[i], 'bonus', 'eventTenLevelBonusReceived', formatOcAmount(transferBonusEvents[i].returnValues.value), 'OC', '', 'eventTenLevelBonusReceived');
            										}
            									}
            								}
            								if (wants('invite-request')) {
            									var requestTxs = {};
            									var receivedRequestEvents = await getCachedEvents('PotentialReferrerRecorded', { filter: { referee: Vue.prototype.info.address } }, 'PotentialReferrerRecorded-referee-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < receivedRequestEvents.length; i++) {
            										var receivedReq = receivedRequestEvents[i].returnValues;
            										requestTxs[receivedRequestEvents[i].transactionHash] = true;
            										await pushOcEventRecord(records, receivedRequestEvents[i], 'invite', 'eventInviteRequested', formatOcAmount(receivedReq.referFee), 'OC', Vue.prototype.hiddenAddress(receivedReq.potentialReferreruint), 'eventInviteRequested');
            									}
            									var sentRequestEvents = await getCachedEvents('PotentialReferrerRecorded', { filter: { potentialReferreruint: Vue.prototype.info.address } }, 'PotentialReferrerRecorded-referrer-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < sentRequestEvents.length; i++) {
            										var sentReq = sentRequestEvents[i].returnValues;
            										if (requestTxs[sentRequestEvents[i].transactionHash]) {
            											continue;
            										}
            										await pushOcEventRecord(records, sentRequestEvents[i], 'invite', 'eventInviteRequested', formatOcAmount(sentReq.referFee), 'OC', Vue.prototype.hiddenAddress(sentReq.referee), 'eventInviteRequested');
            									}
            								}
            								if (wants('invite-confirm')) {
            									var confirmEvents = await getCachedEvents('ReferralConfirmed', { filter: { referrer: Vue.prototype.info.address } }, 'ReferralConfirmed-referrer-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < confirmEvents.length; i++) {
            										await pushOcEventRecord(records, confirmEvents[i], 'invite', 'eventReferralConfirmed', '', '', Vue.prototype.hiddenAddress(confirmEvents[i].returnValues.referee), 'eventReferralConfirmed');
            									}
            								}
            								if (wants('invite-effective')) {
            									var effectiveEvents = await getCachedEvents('EffectiveLpAccountUpdated', { filter: { referrer: Vue.prototype.info.address } }, 'EffectiveLp-referrer-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < effectiveEvents.length; i++) {
            										var ev = effectiveEvents[i].returnValues;
            										await pushOcEventRecord(records, effectiveEvents[i], 'invite', 'eventEffectiveInvite', formatOcAmount(ev.usdtAmount), 'USDT', Vue.prototype.hiddenAddress(ev.account), 'eventEffectiveInvite');
            									}
            								}
            								if (wants('reward-direct') || wants('reward-liquidity')) {
            									var feeTransferEvents = await getCachedEvents('Transfer', {
            										filter: { to: Vue.prototype.info.address }
            									}, 'Transfer-fee-to-' + account + '-' + rangeKey, force, fromBlock, toBlock);
            									for (let i = 0; i < feeTransferEvents.length; i++) {
            										var ft = feeTransferEvents[i];
            										var fv = ft.returnValues;
            										if (!(await txHasOcEvent(ft.transactionHash, 'FeesDistributed(uint256,uint256,uint256)', force))) {
            											continue;
            										}
            										var rewardType = 'liquidity';
            										try {
            											var tradeUsers = await collectTradeUsersFromReceipt(ft.transactionHash, fv.from || '', force);
            											for (let j = 0; j < tradeUsers.length; j++) {
            												var referrer = await getCachedReferrerOf(tradeUsers[j]);
            												if ((referrer || '').toLowerCase() === account) {
            													rewardType = 'direct';
            													break;
            												}
            											}
            										} catch (ignore) {}
            										if ((rewardType === 'direct' && !wants('reward-direct')) || (rewardType === 'liquidity' && !wants('reward-liquidity'))) {
            											continue;
            										}
            										await pushOcEventRecord(records, ft, rewardType, rewardType === 'direct' ? 'eventDirectReward' : 'eventLiquidityReward', formatOcAmount(fv.value), 'OC', Vue.prototype.hiddenAddress(fv.from), rewardType === 'direct' ? 'eventDirectReward' : 'eventLiquidityReward');
            									}
            								}
            								records.sort(function(a, b) {
            									return Number(b.time || 0) - Number(a.time || 0);
            								});
            								return records;
            							};
            							try {
            								var latestBlock = Number(await web3.eth.getBlockNumber());
            								var storedCacheForQuery = force ? { records: [], lastBlock: ocEventFromBlock - 1 } : loadStoredOcEventCache(accountForCache, type);
            								var fromBlock = Math.max(ocEventFromBlock, Number(storedCacheForQuery.lastBlock || 0) + 1);
            								var records = storedCacheForQuery.records || [];
            								var eventQueryChunkSize = 100000;
            								if (isRewardQuery) {
            									Vue.prototype.info.ocEventProgress = {
            										checkedBlock: Math.min(latestBlock, Math.max(ocEventFromBlock - 1, fromBlock - 1)),
            										latestBlock: latestBlock
            									};
            								}
            								if (fromBlock <= latestBlock && isRewardQuery) {
            									var chunkFromBlock = fromBlock;
            									while (chunkFromBlock <= latestBlock) {
            										var chunkToBlock = Math.min(chunkFromBlock + eventQueryChunkSize - 1, latestBlock);
            										var chunkRecords = await loadOcEventRecords(chunkFromBlock, 'delta-' + chunkFromBlock + '-' + chunkToBlock, chunkToBlock);
            										records = mergeOcEventRecords(records, chunkRecords);
            										Vue.prototype.info.ocEventCache[type] = records;
            										saveStoredOcEventCache(accountForCache, type, records, chunkToBlock);
            										if (requestSeq !== Vue.prototype.info.ocEventRequestSeq) return;
            										Vue.prototype.info.ocEventLogs = records;
            										Vue.prototype.info.ocEventProgress = {
            											checkedBlock: chunkToBlock,
            											latestBlock: latestBlock
            										};
            										chunkFromBlock = chunkToBlock + 1;
            									}
            								} else if (fromBlock <= latestBlock) {
            									var freshRecords = await loadOcEventRecords(fromBlock, 'delta-' + fromBlock + '-' + latestBlock, latestBlock);
            									records = mergeOcEventRecords(records, freshRecords);
            								}
            								Vue.prototype.info.ocEventCache[type] = records;
            								saveStoredOcEventCache(accountForCache, type, records, latestBlock);
            								if (requestSeq !== Vue.prototype.info.ocEventRequestSeq) return;
            								Vue.prototype.info.ocEventLogs = records;
            							} catch (error) {
            								console.log(error);
            							} finally {
            								if (requestSeq === Vue.prototype.info.ocEventRequestSeq) {
            									Vue.prototype.info.ocEventLoading = false;
            								}
            							}
            						};
            						Vue.prototype.info.effectiveDirectCount = '0';
            						Vue.prototype.info.effectiveInviteStatus = {};
            						var loadEffectiveInviteInfo = async function() {
            							try {
            								var count = await ocContract.methods.effectiveDirectCount(Vue.prototype.info.address).call({});
            								Vue.prototype.info.effectiveDirectCount = count.toString();
            								var status = {};
            								var refers = Vue.prototype.info.refers || [];
            								await Promise.all(refers.map(async function(addr) {
            									status[addr.toLowerCase()] = await ocContract.methods.effectiveLpAccount(addr).call({});
            								}));
            								Vue.prototype.info.effectiveInviteStatus = status;
            								console.log("oc-effectiveDirectCount: " + Vue.prototype.info.effectiveDirectCount);
            							} catch (error) {
            								console.log(error);
            							}
            						};
            						var loadLbbReferralEvents = async function(eventName, filter, valueName, valueProp, timeProp, logLabel) {
            							try {
            								if (valueProp === 'invites') {
            									try {
            										if (ocContract.methods.getInvites && ocContract.methods.getInviteTimes) {
            											var inviteResult = await Promise.all([
            												ocContract.methods.getInvites(Vue.prototype.info.address).call({}),
            												ocContract.methods.getInviteTimes(Vue.prototype.info.address).call({})
            											]);
            											Vue.prototype.info[valueProp] = inviteResult[0] || [];
            											Vue.prototype.info[timeProp] = inviteResult[1] || [];
            											console.log("oc-" + logLabel + ": " + Vue.prototype.info[valueProp]);
            											console.log("oc-" + logLabel + "Times: " + Vue.prototype.info[timeProp]);
            											return;
            										}
            									} catch (viewError) {
            										console.log("oc-" + logLabel + " view fallback:", viewError);
            									}
            								}
            								if (valueProp === 'refers') {
            									try {
            										if (ocContract.methods.getRefers && ocContract.methods.getRefersTime) {
            											var referResult = await Promise.all([
            												ocContract.methods.getRefers(Vue.prototype.info.address).call({}),
            												ocContract.methods.getRefersTime(Vue.prototype.info.address).call({})
            											]);
            											Vue.prototype.info[valueProp] = referResult[0] || [];
            											Vue.prototype.info[timeProp] = referResult[1] || [];
            											console.log("oc-" + logLabel + ": " + Vue.prototype.info[valueProp]);
            											console.log("oc-" + logLabel + "Times: " + Vue.prototype.info[timeProp]);
            											return;
            										}
            									} catch (viewError) {
            										console.log("oc-" + logLabel + " view fallback:", viewError);
            									}
            								}
            								var events = await ocContract.getPastEvents(eventName, {
            									fromBlock: ocEventFromBlock,
            									toBlock: 'latest',
            									filter: filter
            								});
            								var values = [];
            								var times = [];
            								for (let i = 0; i < events.length; i++) {
            									values.push(events[i].returnValues[valueName]);
            									times.push(await getLbbEventBlockTime(events[i]));
            								}
            								Vue.prototype.info[valueProp] = values;
            								Vue.prototype.info[timeProp] = times;
            								console.log("oc-" + logLabel + ": " + values);
            								console.log("oc-" + logLabel + "Times: " + times);
            							} catch (error) {
            								console.log(error);
            							}
            						};
            						
            						// 邀请人
            						ocContract.methods.referrerOf(Vue.prototype.info.address).call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.referrer = result;
            								console.log("oc-referrer: " + Vue.prototype.info.referrer);
            							} else {
            								console.log(error);
            							}
            						});
            						// 邀请人
            						loadLbbReferralEvents('PotentialReferrerRecorded', { referee: Vue.prototype.info.address }, 'potentialReferreruint', 'invites', 'inviteTimes', 'invites');
            						// 直推
            						loadLbbReferralEvents('ReferralConfirmed', { referrer: Vue.prototype.info.address }, 'referee', 'refers', 'refertimes', 'refers').then(loadEffectiveInviteInfo);
            						// 流动性
            						var pairContractAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}];
            						var pairContract = new web3.eth.Contract(pairContractAbi, Vue.prototype.info.symbols.lp, {});
            						pairContract.methods.totalSupply().call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.lpTotal = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("oc-lpTotal: " + Vue.prototype.info.lpTotal);
            							} else {
            								console.log(error);
            							}
            						});
            						ocContract.methods.totalFeeMarket().call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.totalFeeMarket = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("oc-totalFeeMarket: " + Vue.prototype.info.totalFeeMarket);
            							} else {
            								console.log(error);
            							}
            						});
            						ocContract.methods.totalFeeInvite().call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.totalFeeInvite = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("oc-totalFeeInvite: " + Vue.prototype.info.totalFeeInvite);
            							} else {
            								console.log(error);
            							}
            						});
            						ocContract.methods.totalFeeLps().call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.totalFeeLps = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("oc-totalFeeLps: " + Vue.prototype.info.totalFeeLps);
            							} else {
            								console.log(error);
            							}
            						});
            						ocContract.methods.totalFeeDeads().call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.totalFeeDeads = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("oc-totalFeeDeads: " + Vue.prototype.info.totalFeeDeads);
            							} else {
            								console.log(error);
            							}
            						});
            						ocContract.methods.myFeeInvites(Vue.prototype.info.address).call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.myFeeInvites = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("oc-myFeeInvites: " + Vue.prototype.info.myFeeInvites);
            							} else {
            								console.log(error);
            							}
            						});
            						ocContract.methods.myFeeLps(Vue.prototype.info.address).call({}, function(error, result) {
            							if (!error) {
            								Vue.prototype.info.myFeeLps = (result / 1000000000000000000).toFixed(Vue.prototype.fixScale);
            								console.log("oc-myFeeLps: " + Vue.prototype.info.myFeeLps);
            							} else {
            								console.log(error);
            							}
            						});
            						
            						var lockContractAbi = [{"constant":true,"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"getRecordCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getRecordInfo","outputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"claimable","type":"uint256"},{"internalType":"uint256","name":"total","type":"uint256"},{"internalType":"uint256","name":"released","type":"uint256"},{"internalType":"uint256","name":"timeLeft","type":"uint256"},{"internalType":"bool","name":"active","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"userRecords","outputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"startTime","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"releasedAmount","type":"uint256"},{"internalType":"bool","name":"isActive","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"}];
									var lockContract = new web3.eth.Contract(lockContractAbi, '0x4e46339a934da94626cea6beea1ef8ef47791779', {});
									
									Vue.prototype.info.lockRecords = [];
									Vue.prototype.info.fetchLockRecordsForTarget = function(target) {
										lockContract.methods.getRecordCount(target.address).call({}, async function(error, count) {
											console.log(target.name + "-" + error + "-" + count);
											if (!error) {
												if (target.name === 'query') {
													Vue.prototype.info.lockRecords = [];
												}
												for (let i = 0; i < count; i++) {
													try {
														let info = await lockContract.methods.getRecordInfo(target.address, i).call({});
														let record = await lockContract.methods.userRecords(target.address, i).call({});
														if (info.active) {
															let tokenName = 'Token';
															if (info.token && info.token.toLowerCase() !== '0x0000000000000000000000000000000000000000') {
																for (let key in Vue.prototype.info.symbols) {
																	if (Vue.prototype.info.symbols[key].toLowerCase() === info.token.toLowerCase()) {
																		tokenName = key === 'oc' ? 'OC' : key;
																		break;
																	}
																}
															}
															if (tokenName != 'OC') {
																continue;
															}
															
															if (Number(Vue.prototype.formatUnitsValue(info.total.toString(), 18)) > 1.0) {
																Vue.prototype.info.lockRecords.push({
																	name: target.name,
																	tokenName: tokenName,
																	address: info.token,
																	index: i,
																	total: Number(Vue.prototype.formatUnitsValue(info.total.toString(), 18)).toFixed(4),
																	claimable: Number(Vue.prototype.formatUnitsValue(info.claimable.toString(), 18)).toFixed(4),
																	released: Number(Vue.prototype.formatUnitsValue(info.released.toString(), 18)).toFixed(4),
																	durationDays: (record.duration / 86400).toFixed(0),
																	timeLeftDays: (info.timeLeft / 86400).toFixed(2)
																});
															}
														}
													} catch (e) {
														console.error(e);
													}
												}
											} else {
												console.log(error);
											}
										});
									};
									
									// 默认查询这6个指定的锁仓地址
									const defaultLockTargets = [
										{ name: 'fund5', address: '0x1b93B28EfA713041FECeF64edc87E407Cb494fAd' },
										{ name: 'ecoBurn5', address: '0x0a61E333ac9F60f5E1ECe13b358796285F46e726' },
										{ name: 'genesis5', address: '0x56Ada227587B8a3fbC1E3b50e8fC53293Bc77a4D' },
										{ name: 'tech3', address: '0xe71201F824ce4ba48eFEcA90906b39963826A1BB' },
										{ name: 'market10', address: '0x84c35a5d995A15FbFfe59463dca260463ebC0d9e' },
										{ name: 'coFound30', address: '0xA9E00689F0be96c8ED78339C17C6C212284E654b' }
									];
									Vue.prototype.info.loadLegacyLockRecords = function(force) {
										if (Vue.prototype.info.legacyLockRecordsLoaded && !force) {
											return;
										}
										Vue.prototype.info.legacyLockRecordsLoaded = true;
										Vue.prototype.info.lockRecords = [];
										defaultLockTargets.forEach(t => {
											Vue.prototype.info.fetchLockRecordsForTarget(t);
										});
									};
									
									// 新合约动能挖矿信息
									Vue.prototype.info.lpBonusBalance = '0.0000';
									Vue.prototype.info.lpBonusDistributed = '0.0000';
									Vue.prototype.info.myLpDepth10 = '0.0000';
									Vue.prototype.info.loadLpBonusInfo = function(force) {
										if (Vue.prototype.info.lpBonusInfoLoaded && !force) {
											return;
										}
										Vue.prototype.info.lpBonusInfoLoaded = true;

									Promise.all([
										ocContract.methods.balanceOf(Vue.prototype.info.symbols['oc']).call({}),
										ocContract.methods.totalLockedUnclaimed().call({})
									]).then(function(results) {
										var contractBalance = web3.utils.toBN(results[0]);
										var lockedUnclaimed = web3.utils.toBN(results[1]);
										var available = contractBalance.gt(lockedUnclaimed) ? contractBalance.sub(lockedUnclaimed) : web3.utils.toBN(0);
										Vue.prototype.info.lpBonusBalance = Number(Vue.prototype.formatUnitsValue(available.toString(), 18)).toFixed(4);
									}).catch(function(error) {
										console.log(error);
									});

									ocContract.getPastEvents('BonusDistributed', { fromBlock: ocEventFromBlock, toBlock: 'latest' })
										.then(function(events) {
											var total = web3.utils.toBN(0);
											var bonusTxs = {};
											events.forEach(function(e) {
												total = total.add(web3.utils.toBN(e.returnValues.totalReward));
												bonusTxs[e.transactionHash] = true;
											});
											Vue.prototype.info.lpBonusDistributed = Number(Vue.prototype.formatUnitsValue(total.toString(), 18)).toFixed(4);

											return ocContract.getPastEvents('Transfer', {
												fromBlock: ocEventFromBlock,
												toBlock: 'latest',
												filter: {
													from: Vue.prototype.info.symbols['oc'],
													to: Vue.prototype.info.address
												}
											}).then(function(transferEvents) {
												var myTotal = web3.utils.toBN(0);
												transferEvents.forEach(function(e) {
													if (bonusTxs[e.transactionHash]) {
														myTotal = myTotal.add(web3.utils.toBN(e.returnValues.value));
													}
												});
												Vue.prototype.info.myLpDepth10 = Number(Vue.prototype.formatUnitsValue(myTotal.toString(), 18)).toFixed(4);
												console.log("oc-myLpDepth10: " + Vue.prototype.info.myLpDepth10);
											});
										})
										.catch(function(error) {
											console.log(error);
										});
									};
									Vue.prototype.info.loadPlanetTab = function(tab) {
										if (tab === 1) {
											Vue.prototype.info.loadLpBonusInfo();
										}
										if (tab === 2) {
											Vue.prototype.info.loadLegacyLockRecords();
										}
									};
            						
            						
            						console.log("Connect Address: " + Vue.prototype.info.address);
            					} else {
            						console.log(error);
            					}
            				});
            			}
            			console.log("C Chain: " + res);
            		} else {
            			console.log(err);
            		}
            	});
            }
            
        }
    }
}, 100);

Vue.prototype.preEndExecs = {
	'invite': ['CC', 'inviteDesc', '&img=invite&lid=zdoing&jump=index'],
	'ccNodeBuy0': ['CC', 'nodeBuy0', '&img=node0&lid=zdoing&jump=index'],
	'ccNodeBuy1': ['CC', 'nodeBuy1', '&img=node1&lid=zdoing&jump=index'],
	'ccNodeBuy2': ['CC', 'nodeBuy2', '&img=node2&lid=zdoing&jump=index'],
	'tokenNodeBuy0': ['', 'nodeBuy0', '&img=node0&lid=zdoing&jump=index'],
	'tokenNodeBuy1': ['', 'nodeBuy1', '&img=node1&lid=zdoing&jump=index'],
	'tokenNodeBuy2': ['', 'nodeBuy2', '&img=node2&lid=zdoing&jump=index'],
	'ccMarketBuy': ['CC', 'marketBuy', '&img=market&lid=zdoing&jump=index'],
	'tokenMarketBuy': ['', 'marketBuy', '&img=market&lid=zdoing&jump=index'],
	'ccExtra': ['CC', 'nodeMarketExtra', '&img=unlock&lid=zdoing&jump=index'],
	'usdtExtra': ['', 'nodeMarketExtra', '&img=unlock&lid=zdoing&jump=index'],
	'ccSmall': ['CC', 'nodeMarketSmall', '&img=unlock&lid=zdoing&jump=index'],
	'nodeTransfer': ['CC', 'nodeTransfer', '&img=node&lid=zdoing&jump=index'],
	'ccWithdraw': ['CC', 'ccWithdraw', '&img=withdraw&lid=zdoing&jump=index']
};

Vue.prototype.doTransfer = function(...params) {
	if (Vue.prototype.preEndExecs[params[0]]) {
		Vue.prototype.confirm(Vue.prototype.t('chainConfirm'), Vue.prototype.t(Vue.prototype.preEndExecs[params[0]][1]), 
			() => {
				if (Vue.prototype.preEndExecs[params[0]][0] == 'CC') {
					Vue.prototype.doTransferCc(params[1], params[2], params[3], Vue.prototype.preEndExecs[params[0]][2]);
				} else {
					Vue.prototype.doTransfer18(params[1], params[2], params[3], params[4], Vue.prototype.preEndExecs[params[0]][2]);
				}
			});
	} else {
		Vue.prototype.toast('Call Params Error');
	}
}

Vue.prototype.doTransferCc = function(to, cnt, other, flag) {
	var timeTransfer18 = uni.getStorageSync("timeTransfer18");
	if (timeTransfer18 && ((timeTransfer18 + Vue.prototype.transferTimeLimit) > new Date().getTime())) {
		Vue.prototype.toast(Vue.prototype.t("{0} Operate Fast").replace("{0}", "Chain").replace("{1}", parseInt((timeTransfer18 + Vue.prototype.transferTimeLimit - new Date().getTime()) / 1000)));
		return false;
	}
	
	var cntNeed = parseFloat(cnt) + parseFloat(web3.utils.fromWei(Vue.prototype.info.gasPrice * Vue.prototype.info.gasLimit + ''));
	if (cnt <= 0 || Vue.prototype.info.CC < cntNeed) {
		Vue.prototype.toast(Vue.prototype.t("{0} Not Enogugh").replace("{0}", 'CC'));
		return false;
	}
	var extraStr = other;
	var extra = "";
	for(var i = 0; i < extraStr.length; i++){
		extra += extraStr.charCodeAt(i).toString(16);
	}
	var message = {
		from: Vue.prototype.info.address,
		to: to,
		value: web3.utils.toWei(cnt + '', 'ether'),
		gas: Vue.prototype.info.gasLimit + '',
		gasPrice: (Vue.prototype.info.gasPrice * 1000) + '',
		data: extra
	};
	web3.eth.sendTransaction(message, (err, res) => {
		if (!err) {
			uni.setStorageSync("timeTransfer18", new Date().getTime());
			if (flag) {
				uni.navigateTo({
					url: 'box?&hash=' + res + flag,
				});
			} else {
				Vue.prototype.toast(Vue.prototype.t("Operate Success"));
				setTimeout(function() {
					window.location.reload();
				}, 3000)
			}
			console.log(res);
		} else {
			console.log(err);
		}
	});
},

Vue.prototype.doTransfer18 = function(symbol, to, cnt, other, flag) {
	var timeTransfer18 = uni.getStorageSync("timeTransfer18");
	if (timeTransfer18 && ((timeTransfer18 + Vue.prototype.transferTimeLimit) > new Date().getTime())) {
		Vue.prototype.toast(Vue.prototype.t("{0} Operate Fast").replace("{0}", "Chain").replace("{1}", parseInt((timeTransfer18 + Vue.prototype.transferTimeLimit - new Date().getTime()) / 1000)));
		return false;
	}
	
	var feeNeed = parseFloat(web3.utils.fromWei(Vue.prototype.info.gasPrice * Vue.prototype.info.gasLimit + ''));
	if (Vue.prototype.info.CC < feeNeed) {
		Vue.prototype.toast(Vue.prototype.t("{0} Not Enogugh").replace("{0}", 'CC'));
		return false;
	}
	
	if (!cnt || cnt < 0 || parseFloat(Vue.prototype.info[symbol]) < cnt) {
		Vue.prototype.toast(Vue.prototype.t("{0} Not Enogugh").replace("{0}", symbol));
		return false;
	}
	
	let val2 = (parseFloat(cnt).toFixed(9) * Math.pow(10, 18)).toString(16)
	let valPrefix = "";
	for (let i = 0; i < (64 - val2.length); i++) {
		valPrefix = valPrefix + "0";
	}
	val2 = valPrefix + val2;
	
	var extra="";
	if (other) {
		for(var i = 0; i < other.length; i++){
			extra += other.charCodeAt(i).toString(16);
		}
	}
	
	web3.eth.sendTransaction({ // https://www.liankexing.com/question/1634
		from: Vue.prototype.info.address,
		to: Vue.prototype.info.symbols[symbol], // 平台币是接受者地址，代币是合约地址
		gas: web3.utils.numberToHex(Vue.prototype.info.gasLimit), // 含额外信息所以要大一些500000
		gasPrice: web3.utils.numberToHex(Vue.prototype.info.gasPrice), // 98 gwei
		value: '', // 平台币是转账数量，代币是空
		data: '0xa9059cbb000000000000000000000000' + to.substring(2) + val2 + extra,
	}, function(error, res){
		if (!error) {
			uni.setStorageSync("timeTransfer18", new Date().getTime());
			if (flag) {
				uni.navigateTo({
					url: 'box?&hash=' + res + flag,
				});
			} else {
				Vue.prototype.toast(Vue.prototype.t("Operate Success"));
				setTimeout(function() {
					window.location.reload();
				}, 3000)
			}
			console.log(res);
		} else {
			console.log(error);
		}
	});
},

Vue.prototype.doTransferNft = function(to, mid, other) {
	var timeTransfer18 = uni.getStorageSync("timeTransfer18");
	if (timeTransfer18 && ((timeTransfer18 + Vue.prototype.transferTimeLimit) > new Date().getTime())) {
		Vue.prototype.toast(Vue.prototype.t("{0} Operate Fast").replace("{0}", "Chain").replace("{1}", parseInt((timeTransfer18 + Vue.prototype.transferTimeLimit - new Date().getTime()) / 1000)));
		return false;
	}
	
	if (parseFloat(Vue.prototype.info.CC) < Vue.prototype.info.osnftWithdrawFee) {
		Vue.prototype.toast(Vue.prototype.t("{0} Not Enogugh").replace("{0}", "CC"));
		return false;
	}
	
	if (to == Vue.prototype.info.osnftTradeAddress && (!other || other.indexOf('-') <= 0 || !other.split('-')[1] || parseFloat(other.split('-')[1]) < 1)) {
		Vue.prototype.toast('Price is Min 1 OSC');
		return false;
	}
	
	let val2 = mid.toString(16)
	let valPrefix = "";
	for (let i = 0; i < (64 - val2.length); i++) {
		valPrefix = valPrefix + "0";
	}
	val2 = valPrefix + val2;
	
	var extra="";
	if (other) {
		for(var i = 0; i < other.length; i++){
			extra += other.charCodeAt(i).toString(16);
		}
	}
	
	web3.eth.sendTransaction({ // https://www.liankexing.com/question/1634
		from: Vue.prototype.info.address,
		to: "0x9055244c90A249376B18A814C5581ac3523a7Fe1".toLowerCase(), // 平台币是接受者地址，代币是合约地址
		gas: '0x7A120', // 含额外信息所以要大一些500000
		gasPrice: '0x16d1415400', // 98 gwei
		value: '', // 平台币是转账数量，代币是空
		data: '0x42842e0e000000000000000000000000' + Vue.prototype.info.address.toLowerCase().substring(2) + '000000000000000000000000' + to.substring(2) + val2 + extra,
	}, function(error, hash){
		if (!error) {
			uni.setStorageSync("timeTransfer18", new Date().getTime());
			if(to == Vue.prototype.info.osnftTradeAddress) {
				
			} else {
				Vue.prototype.toast(Vue.prototype.t("Operate Success"));
				setTimeout(function() {
					window.location.reload();
				}, 3000)
			}
			console.log(hash);
		} else {
			console.log(error);
		}
	});
}

Vue.prototype.doInit = function() {
	if (Vue.prototype.info.address == '0x0000000000000000000000000000000000000000') {
		return;
	}
	uni.request({
		url: "https://api.cchain-gov.org/chain/gasPrices",
		method: 'GET',
		header: {
			'content-type': 'application/x-www-form-urlencoded',
		},
		data: {},
		success: (res) => {
			if (res.data.code == 10000) {
				for (let key in res.data.data) {
					Vue.prototype.info[key] = res.data.data[key];
				}
				// uni.setStorageSync("info", res.data.data);
			}
		}
	});
}

Vue.prototype.num = 0;
setInterval(function(){
	if (Vue.prototype.num < 150) {
		Vue.prototype.num = Vue.prototype.num + 1;
		Vue.prototype.doInit();
	}
}, 6000);

import * as custom from './util/util'
Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})
// 请求方法
import http from './util/request/index.js'
Vue.prototype.$http = http
const app = new Vue({
  store,
  ...App
})


app.$mount()